import * as z from "zod/v4";

const sessionSubstepSchema = z.object({
  visited: z.boolean().optional(),
  timeSpent: z.number().optional(),
});

const sessionStepSchema = z.object({
  visited: z.boolean().optional(),
  timeSpent: z.number().optional(),
  substeps: z.record(z.string(), sessionSubstepSchema).optional(),
});

const merchantSessionSchema = z.object({
  sessionId: z.string(),
  startedAt: z.string(),
  totalTimeSeconds: z.number().nullable(),
  progress: z.string().nullable(),
  steps: z.record(z.string(), sessionStepSchema).nullable(),
});

export const getMerchantSessions = {
  name: "getMerchantSessions" as const,
  input: z.object({
    merchantId: z.string(),
    product: z.string().optional(),
    limit: z.number().min(1).max(100).default(20),
    offset: z.number().min(0).default(0),
  }),
  output: z.object({
    sessions: z.array(merchantSessionSchema),
    total: z.number(),
    hasMore: z.boolean(),
  }),
};

export type MerchantSession = z.infer<typeof merchantSessionSchema>;
export type GetMerchantSessionsInput = z.infer<
  typeof getMerchantSessions.input
>;
export type GetMerchantSessionsOutput = z.infer<
  typeof getMerchantSessions.output
>;
